import React from 'react';
import './KPICard.css';

const KPICard = ({ title, count, value, color, icon, description }) => {
  return (
    <div className={`kpi-card kpi-card-${color}`}>
      <div className="kpi-header">
        <div className="kpi-icon-container">
          <span className="kpi-icon">{icon}</span>
        </div>
        <div className="kpi-title-section">
          <h3 className="kpi-title">{title}</h3>
          <p className="kpi-description">{description}</p>
        </div>
      </div>
      
      <div className="kpi-content">
        <div className="kpi-metric">
          <div className="kpi-value">{count}</div>
          <div className="kpi-label">USUARIOS</div>
        </div>
        <div className="kpi-divider"></div>
        <div className="kpi-metric">
          <div className="kpi-value">€{value}</div>
          <div className="kpi-label">TOTAL EUR</div>
        </div>
      </div>
      
      <div className="kpi-glow"></div>
    </div>
  );
};

export default KPICard;